module.exports = __webpack_public_path__ + "static/media/2025_ral-logo-red.74569890.png";